import React, { useContext, ReactNode } from 'react'

interface TrackingContextType {
  sourcePagePath: string
}

interface TrackingProviderProps {
  children: ReactNode
  canonicalUrl: string
}

const TrackingContext = React.createContext<TrackingContextType | undefined>(undefined)

export const useTrackingContext = () => {
  const tracking = useContext(TrackingContext)
  if (!tracking) throw new Error('useTrackingContext must be used within TrackingProvider')
  return tracking
}

export const TrackingProvider: React.FC<TrackingProviderProps> = ({ children, canonicalUrl }) => {
  const url = new URL(canonicalUrl)
  return (
    <TrackingContext.Provider
      value={{
        sourcePagePath: url.pathname,
      }}
    >
      {children}
    </TrackingContext.Provider>
  )
}
